import { HttpClient } from '@angular/common/http';
import {ApiService} from '../../shared';
import {Mensaje} from "../index";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class MensajeService extends ApiService<Mensaje>{
  protected dataKey = 'mensajes';
  protected objectKey = 'Mensajes';
  protected sendObjectKey = 'mensajes';
  protected sendObjectIdsKey = 'mensajesIds';
  protected reciveObjectKey = 'mensaje';

  constructor(protected httpClient: HttpClient) {
    super( Mensaje, httpClient);
  }
}
